import styled from "styled-components";

export const StyledUploadeContainer = styled.div`
    position: relative;
    
     .upload-action-menu{
      display: flex;
      > div{
       width:100%;
       button{
        width:100%;
       }
      }
    }
    .btn-upload-toggler{
    border-radius:0;
    }
    .ant-slider-rail {
    background-color: rgba(0, 0, 0, 0.2);}
`
export const StyledUploadContent = styled.div`
position: relative;
width: 1000%;
border: 2px solid #ddd;
padding:2px;
    overflow: auto;
 .no-file-found{
     width: 100%; 
     min-height: 250px;
     display: flex;
     align-items: center;
     justify-content: center;
     color:rgba(0,0,0,0.5);
     font-size:16px;
 }

.upload-list-item {
 color:var(--text-black);
  padding:5px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  h2{
      margin: 0;
      font-size: 1.565rem;
      text-transform: capitalize;
  }
  small{
  color:rgba(0,0,0,0.5);
  margin-right:10px;
  }
  .file-info{
   margin-bottom:10px;
  }
  &:last-child{
   border-bottom: none;
  }
}

&.split-view{
  .view-wrapper{
    padding:5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
     .no-file-found{
       border:1px dashed rgba(0,0,0,0.15)
     }
}
`
export const StyledUploadHeader = styled.div`
     padding:0px 5px;
    .filter{
       padding:10px;
     }
    .filter-reset-link{
      color:var(--text-blue-title);
      margin-bottom: 10px;
      font-weight:500;
      text-decoration: none;
      &:hover{
       color:var(--text-blue-dark-hover);
      }
    }
   .btn-reset-action{
      padding:0;
      height: auto; 
      font-size:16px;
      color:var(--text-blue-dark);
    }

    .filter-item{
    padding-right:10px;
     label{
     color:var(--text-black);
     font-size:14px;
     font-weight:500;
     margin:0;
     padding:0;
     }
     .ant-slider-mark-text{
       font-size:12px;
       font-weight:400;
       padding-left:10px;
     }
      .ant-slider-horizontal.ant-slider-with-marks {
        margin-top: 2px;
      }
    }
      .split-view{
      background:var(--light-smoke-grey);
      border-radius:4px;
      }
`